import { render } from "./StateOfChildForm.vue?vue&type=template&id=2de21f4b&ts=true"
import script from "./StateOfChildForm.vue?vue&type=script&lang=ts"
export * from "./StateOfChildForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__